import {Component, OnInit, AfterViewInit} from '@angular/core';
import {BrowserDetectorService} from './shared/browser-detector.service';
import {WindowRefService} from './shared/window-ref-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  constructor(
    private _browserDetectorService: BrowserDetectorService,
    private windowRef: WindowRefService
  ) {
  }

  scrollToArgs = {
    duration: 800,
    easing: 'easeInOutQuart',
    offset: (((): number => {
      let offset = 0;
      if (this._browserDetectorService.isFirefox) {
        offset = -1;
      }

      return offset;
    })()),

    // Do not use these until this bug is fixed:
    // https://github.com/kavil/ng2SmoothScroll/issues/1#issuecomment-331788227
    callbackBefore: undefined,
    callbackAfter: undefined,
  };

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.dismissSplashScreen();
  }

  dismissSplashScreen() {
    if (!this.windowRef.nativeWindow || !this.windowRef.nativeWindow.appSplashScreens || !this.windowRef.nativeWindow.appSplashScreens[0]) {
      console.warn('Could not find the splash screen!');
      return;
    }

    const splashScreen = this.windowRef.nativeWindow.appSplashScreens[0];
    splashScreen.classList.add('loading-indicator-dismissed');
  }
}



// WEBPACK FOOTER //
// C:/Projects/dod/companyintroduction/src/app/app.component.ts